import { render, staticRenderFns } from "./panelCard.vue?vue&type=template&id=f80329cc&scoped=true"
import script from "./panelCard.vue?vue&type=script&lang=js"
export * from "./panelCard.vue?vue&type=script&lang=js"
import style0 from "./panelCard.vue?vue&type=style&index=0&id=f80329cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80329cc",
  null
  
)

export default component.exports